<template>
  <div class="base-bg" v-if="visible">
    <TopBar :title="$t('edit.editActionTitles.startAnimation')" @onClickClose="close" @onClickSave="handleSubmit">
    </TopBar>
    <div class="set-content">
      <a-row>
        <a-col>
          <a-form-model layout="vertical" ref="ruleForm" :form="form" :model="form">
            <a-form-model-item has-feedback>
              <a-radio-group class="func-cell" v-for="(item, index) in $t('edit.editActionTitles.startAnimationArr')"
                :key="index" v-model="form.start_animation">
                <a-radio :value="index">{{ item }}</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-form-model>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import TopBar from "./TopBar.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    TopBar,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        start_animation: 0,
      },
    };
  },
  computed: { ...mapGetters(["vrbase"]) },
  created() {
    this.form.start_animation = this.vrbase.sets.start_animation;
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleSubmit() {
      const vrbase = {
        ...this.vrbase,
        sets: { ...this.vrbase.sets, start_animation: this.form.start_animation },
      }
      this.$store
        .dispatch("saveVRBase", {
          vrbase,
          showLoading: true,
        })
        .then(() => {
          this.$emit("close");
        });
    },
  },
};
</script>

<style lang="less" scoped>
.base-bg {

  /deep/ .ant-input,
  /deep/ .ant-select-selection,
  /deep/ .ant-input-number-input {
    background-color: #333 !important;
    border: 1px solid #555;
    color: #fff;
  }

  /deep/ .ant-form-item-label>label {
    color: #fff !important;
  }

  /deep/ span+* {
    color: #fff;
  }

  .func-cell {
    padding: 15px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, .08);
    box-shadow: 0 1px 0 0 rgba(255, 255, 255, .05);
  }
}</style>